import { createApp } from 'vue';
import { createPinia } from 'pinia';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap'; // JS (dropdowns, collapse, modals)
import './assets/klinger.css'; // Klinger-tokens/knopstijlen (uit eportal) — ná Bootstrap, zodat ze winnen
import './assets/app.css';
import App from './App.vue';
import { router } from './router';

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.mount('#app');
